// Where an item of the menu leads: the first page of a section or a folder, and the list a person last opened for each type.

import type { MenuItems, MenuSection, MetaIndex } from '@confdeck/core-shared';
import { typeHref } from './router.ts';

/** The first page of a node in the order the menu shows it: sections of records, views, screens, then folders; a fixed screen only if nothing else. */
export function firstHref(node: MenuItems, meta: MetaIndex): string | null {
  for (const id of node.typeIds) { const t = meta.type(id); if (t) return typeHref(t.key); }
  for (const v of node.views ?? []) { const t = meta.type(v.typeId); if (t) return typeHref(t.key, v.viewId); }
  for (const sc of node.screens ?? []) if (!sc.foot) return `/s/${sc.key}`;
  for (const g of node.groups ?? []) { const h = firstHref(g, meta); if (h) return h; }
  // A section with nothing but a fixed screen (a role that sees only the door) opens that screen.
  for (const sc of node.screens ?? []) return `/s/${sc.key}`;
  return null;
}
/** What the rail button of a section opens: its own start screen, or its first page. */
export const sectionHref = (m: MenuSection, meta: MetaIndex) => (m.start ? `/s/${m.start}` : firstHref(m, meta));

// The list (a view of a section) a record was opened from: the crumb and «назад» after a direct visit lead there.
const lists = new Map<string, string>();
export const rememberList = (typeId: string, href: string) => { lists.set(typeId, href); };
export const listOf = (typeId: string) => lists.get(typeId);
